import type { AccountClass } from '@taler/api-client'
import { computed, type ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { clampToToday, parseClassParam, parseDateParam } from '../internal/query-params.ts'

const DEFAULT_CLASS: AccountClass = 'EXPENSE'

export interface ParentRollupQueryState {
  readonly accountClass: ComputedRef<AccountClass>
  readonly until: ComputedRef<string>
  setAccountClass(next: AccountClass): void
  setUntil(next: string): void
}

/** `class` and `until` live in the URL, so a shared link reopens on the same view. No date may pass today. */
export function useParentRollupQueryState(today: () => string): ParentRollupQueryState {
  const route = useRoute()
  const router = useRouter()

  const update = (patch: Record<string, string | undefined>): void => {
    void router.replace({ query: { ...route.query, ...patch } })
  }

  return {
    accountClass: computed(() => parseClassParam(route.query['class'], DEFAULT_CLASS)),
    until: computed(() => clampToToday(parseDateParam(route.query['until'], today()), today())),
    setAccountClass: (next) => update({ class: next === DEFAULT_CLASS ? undefined : next }),
    setUntil: (next) => {
      const until = clampToToday(next, today())
      update({ until: until === today() ? undefined : until })
    },
  }
}
